import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const reload = () => api.get("/categories").then((r) => setCategories(r.data)).finally(() => setLoading(false));
  useEffect(() => { reload(); }, []);
  return { categories, loading, reload };
}
